

export class PoiVehicleOutputWithoutStatus implements IPoiVehicleOutputWithoutStatus {
    /** The auto-generated id of the poi vehicle master */
    poi_vehicle_id!: number;
    /** The auto-generated id of the poi master */
    poi_details_id!: number;
    /** The place name with 255 character limit */
    place_name!: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The vehicle number with vehicle name */
    vehicle_number!: string;

    constructor(data?: IPoiVehicleOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poi_vehicle_id = _data["poi_vehicle_id"];
            this.poi_details_id = _data["poi_details_id"];
            this.place_name = _data["place_name"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.vehicle_number = _data["vehicle_number"];
        }
    }

    static fromJS(data: any): PoiVehicleOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PoiVehicleOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poi_vehicle_id"] = this.poi_vehicle_id;
        data["poi_details_id"] = this.poi_details_id;
        data["place_name"] = this.place_name;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["vehicle_number"] = this.vehicle_number;
        return data; 
    }
}

export interface IPoiVehicleOutputWithoutStatus {
    /** The auto-generated id of the poi vehicle master */
    poi_vehicle_id: number;
    /** The auto-generated id of the poi master */
    poi_details_id: number;
    /** The place name with 255 character limit */
    place_name: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The vehicle number with vehicle name */
    vehicle_number: string;
}

